import feather from 'feather-icons'

window.feather = feather
document.addEventListener('turbo:load', function () {
  feather.replace()
})
